export const PREPAYMENT_DOC_TYPE = '预付款申请';
export const LOAN_DOC_TYPE = '借款申请';

export const PREPAYMENT_DOC_TYPE_OPTIONS = [
  { value: PREPAYMENT_DOC_TYPE, label: PREPAYMENT_DOC_TYPE },
  { value: LOAN_DOC_TYPE, label: LOAN_DOC_TYPE }
];

export function isLoanDocType(docType) {
  return String(docType || PREPAYMENT_DOC_TYPE).trim() === LOAN_DOC_TYPE;
}

/** 业务短名：预付款 / 借款 */
export function resolvePrepaymentBizWord(docType) {
  return isLoanDocType(docType) ? '借款' : '预付款';
}

export function prepaymentLineSectionTitle(docType) {
  return `${resolvePrepaymentBizWord(docType)}明细`;
}

export function prepaymentAddLineButtonLabel(docType) {
  return `新增${resolvePrepaymentBizWord(docType)}明细`;
}

export function prepaymentAmountLabel(docType) {
  return `${resolvePrepaymentBizWord(docType)}金额`;
}

export function prepaymentTotalLabel(docType) {
  return `${resolvePrepaymentBizWord(docType)}合计`;
}

export function prepaymentTotalSummaryLabel(docType) {
  return `${resolvePrepaymentBizWord(docType)}总额`;
}

export function prepaymentReasonPlaceholder(docType) {
  return `简要说明${resolvePrepaymentBizWord(docType)}事由`;
}
